import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Style from "../Style/Banner.module.scss";
import logo from "../Img/logo9.png";

const Banner = ({ darkMode }) => {
  const [showSearch, setShowSearch] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  const location = useLocation();

  const toggleSearch = () => setShowSearch((prev) => !prev);
  const toggleMenu = () => setMenuOpen((prev) => !prev);

  useEffect(() => {
    const handleScroll = () => {
      const totalScroll = document.documentElement.scrollTop;
      const windowHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const scroll = (totalScroll / windowHeight) * 100;
      setScrollProgress(scroll);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`${Style.banner} ${darkMode ? Style.dark : ""}`}>
      <div className={Style.wrapper}>
        <div className={Style.BannerFlex}>
          <div className={Style.logoText}>
            <Link to="/">
              <img src={logo} alt="logo" />
            </Link>
          </div>

          <div className={`${Style.navMenu} ${menuOpen ? Style.openMenu : ""}`}>
            <Link
              to="/"
              className={location.pathname === "/" ? Style.active : ""}
              onClick={() => setMenuOpen(false)}
            >
              HOME
            </Link>
            <Link
              to="/about-us"
              className={location.pathname === "/about-us" ? Style.active : ""}
              onClick={() => setMenuOpen(false)}
            >
              ABOUT US
            </Link>
            <Link
              to="/courses"
              className={location.pathname === "/courses" ? Style.active : ""}
              onClick={() => setMenuOpen(false)}
            >
              COURSES
            </Link>
            <Link
              to="/gallery"
              className={location.pathname === "/gallery" ? Style.active : ""}
              onClick={() => setMenuOpen(false)}
            >
              GALLERY
            </Link>
            <Link
              to="/contact"
              className={location.pathname === "/contact" ? Style.active : ""}
              onClick={() => setMenuOpen(false)}
            >
              CONTACT-US
            </Link>
          </div>

          <div
            className={`${Style.SidebarNav} ${menuOpen ? Style.toggle : ""}`}
            onClick={toggleMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
      <div
        className={Style.scrollBar}
        style={{ width: `${scrollProgress}%` }}
      ></div>
    </div>
  );
};

export default Banner;
